import { Company } from "../../domain/model/company";

interface IGetCompanyByClientBillingResponse {
  company?: Company;
}
class GetCompanyByClientBillingResponse
  implements IGetCompanyByClientBillingResponse
{
  public company: Company;
}

interface ICreatePaymentInfoByClientBillingResponse {
  company?: Company;
}
class CreatePaymentInfoByClientBillingResponse
  implements ICreatePaymentInfoByClientBillingResponse
{
  public company: Company;
}

export {
  CreatePaymentInfoByClientBillingResponse,
  GetCompanyByClientBillingResponse,
};



// WEBPACK FOOTER //
// ./src/presentation/response/company_response.ts